<script setup lang="ts">
import type { MenuItem } from '@global-types/nav/menuItem';
import { computed } from 'vue';
import { trans } from '@elements/translation';
import Icon from '@components/Icon.vue';
import Tag from '@components/Tag.vue';
import Typography from '@components/Typography.vue';
import { useUserProfile } from '@pages/pay/composables/useUserProfile';

interface Submenu {
  name: string;
  link: string;
}

interface DesktopVerticalMenuButtonProps {
  submenus: MenuItem[];
  icon: string;
  iconName?: string;
  hasIconStroke?: boolean,
  isOpen: boolean,
  isCurrentCategory: boolean,
  isCollapsed: boolean,
  isNew?: boolean,
}

const props = defineProps<DesktopVerticalMenuButtonProps>();

const {
  hasKYCActive,
} = useUserProfile();

const showNewTag = computed<boolean>(() => props.isNew && !hasKYCActive.value);
</script>

<template>
  <div
    class="side-bar-menu__title vertical-menu-item vertical-menu-item--button"
    :class="{
      'side-bar-menu__title--opened': isOpen,
      'side-bar-menu--current-category': isCurrentCategory
    }"
  >
    <div class="vertical-menu-item--button__content">
      <div class="vertical-menu-item__icon" :class="icon">
        <Tag
          v-if="showNewTag && isCollapsed"
          text-color="purple"
          background-color="purple-lighter"
          class="vertical-menu-item-icon__new-tag"
        >
          {{ trans('gestion.tag.new') }}
        </Tag>
        <Icon
          v-if="hasIconStroke"
          :svg="icon"
          :custom-class="iconName"
          height="24"
          width="24"
          fill="none"
          stroke="gray-darker"
        />
        <Icon
          v-else
          :svg="icon"
          :custom-class="iconName"
          height="24"
          width="24"
          fill="gray-darker"
        />
      </div>

      <Typography
        v-if="!isCollapsed"
        variant="body-small"
      >
        <slot />
      </Typography>

      <Tag
        v-if="showNewTag && !isCollapsed"
        text-color="purple"
        background-color="purple-lighter"
        class="vertical-menu-item-button-content__new-tag"
      >
        {{ trans('gestion.tag.new') }}
      </Tag>
    </div>
  </div>
</template>
